exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selling-revenue-content{position:relative;left:308px;background-color:#fff;min-height:calc(100% - 191px);padding:30px}.revenue-title{font-family:NanumBarunGothicOTF;font-size:32px;font-weight:400}.revenue-total-cost{font-family:NanumBarunGothicUltraLightOTF;font-size:36px;margin:10px 0}.revenue-cost{color:#4b74ff;font-weight:700}.revenue-chart{width:770px;height:477px;border-radius:3px;box-shadow:0 0 10px 0 hsla(0,0%,85%,.43);background-color:#fff}.revenue-check{display:flex}.RevenueChk1{margin-top:37px;margin-left:40px;display:flex;align-items:center}.revenue-chk-box{width:28px;height:28px;border:.5px solid #d9d9d9;overflow:hidden}.revenue-chked-box{width:27px;height:27px;object-fit:contain;transform:translate(-.5px,-.5px)}.revenue-chk-tag{height:28px;font-family:NanumBarunGothicOTF;font-size:20px;line-height:28px;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d7f79a9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SellerManager/Revenue.vue
// module id = 220
// module chunks = 0